import { render, staticRenderFns } from "./People.vue?vue&type=template&id=10dcd4e8&scoped=true&"
var script = {}
import style0 from "./People.vue?vue&type=style&index=0&id=10dcd4e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dcd4e8",
  null
  
)

export default component.exports